import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * Container for list of tags
 * */
export function TagsList({ children, className }) {
  return <div className={cx(className)}>{children}</div>;
}

TagsList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

/**
 * Colored tag with text
 */
export function TagsItem({ children, color, className }) {
  return (
    <div className={cx('component', className)} style={{ borderColor: color, color }}>
      {children}
    </div>
  );
}

TagsItem.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string,
  className: PropTypes.string,
};
